import React from "react";
import { useTranslation } from "react-i18next";
import Modal from "../modal/Modal";
import PolicyText from "./PolicyText";

const PolicyModal = ({ isOpen, onClose, policyType }) => {
  const { t } = useTranslation("policies");

  if (!policyType) return null;

  const data = t(policyType, { returnObjects: true });

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={data.title}
      id={`policy-${policyType}`}
    >
      <PolicyText data={data} />

    </Modal>
  );
};

export default PolicyModal;
